









































import { Component, Mixins, Prop, Provide, Vue } from 'vue-property-decorator'
import { finishTask, saveExtraData, sendMessage } from '../../../../service/platform'
import { FinishTaskData, TaskInstance } from '../../types/task'
import { ConstantMixin } from './ConstantMixin'
import { OperationMixin } from './OperationMixin'
import { Record } from './Record'
import ImageSample from './common/ImageSample.vue'

@Component({
  components: { ImageSample }
})
export default class JzdxRejectInfo extends Mixins(OperationMixin, ConstantMixin, Record) {
  public get jzdxComment() {
    return (
      this.data &&
      this.data.resource &&
      this.data.resource.extras &&
      this.data.resource.extras.comment_content
    )
  }

  // public reject_reason = '' // 拒绝原因

  public reject_reason = '作品涉及敏感内容'

  public get sensitive_type() {
    return this.extraData.content_data[0].sensitive_type
  }
  public set sensitive_type(val: number[]) {
    this.extraData.content_data[0].sensitive_type = val
  }

  public get content() {
    return this.extraData.content_data[0].content
  }
  public set content(val: string) {
    this.extraData.content_data[0].content = val
  }

  public async submit() {
    if (!this.reject_reason) {
      this.$message.info('拒绝原因不能为空')
      return
    }

    this.content = this.jzdxComment as string
    this.extraData.type = 'REJECT'
    this.extraData.detail = this.reject_reason
    const saveRet = await saveExtraData(this.extraData)
    if (!saveRet.success) return

    const submitData: FinishTaskData = {
      instance_id: this.data.id,
      task_id: this.data.current_task.id,
      approve_result: 'REJECT',
      approve_reason: this.reject_reason,
      variable_data_json: '',
      extra_operation_data_json: ''
    }
    this.getFinishTime({
      instance_id: this.data.id,
      task_id: this.data.current_task.id,
      step: 'submit'
    })
    let retData = await finishTask(submitData)
    if (retData.success) {
      this.close(true)
    }
  }
}
